import React, { useState, useEffect } from "react";
import "./MapaTab.scss";
import { BiCheck } from "react-icons/bi";
import { MdWarning, MdInfo } from "react-icons/md";
import MapComponent from "../../../common/MapComponent/MapComponent";

const centrosProductoresMapData = [
    {
        id: 1,
        nombre: "Centro Edificio Singular",
        direccion: "España",
        lat: 40.4168,
        lng: -3.7038,
        fechaInicio: "15/05/2025",
        fechaFin: "15/05/2026",
        intermediario: "-",
        cadena: "Edificio singular",
        tipoCentro: "Obra singular",
        estado: "EN PROCESO",
        codigoEspacio: "#0123",
        codigoObra: "-",
        badgeIcon: <MdWarning />,
        cumplimiento: "En proceso",
        cantidadGenerada: "1500 kg",
        coste: "800 €",
        valorizacion: 65,
    },
    {
        id: 2,
        nombre: "Oysho Passeig de Gràcia",
        direccion: "Passeig de Gràcia 13, Barcelona, España",
        lat: 41.3851,
        lng: 2.1734,
        fechaInicio: "18/02/2025",
        fechaFin: "04/06/2025",
        intermediario: "Incoga",
        cadena: "Oysho",
        tipoCentro: "Obra reforma",
        estado: "EN PROCESO",
        codigoEspacio: "#10202",
        codigoObra: "R12",
        badgeIcon: <MdWarning />,
        cumplimiento: "En proceso",
        cantidadGenerada: "2200 kg",
        coste: "1100 €",
        valorizacion: 78,
    },
    {
        id: 3,
        nombre: "Oysho Platja d'Aro",
        direccion: "Platja d'Aro, Castell Platja d'Aro, España",
        lat: 41.8169,
        lng: 3.0674,
        fechaInicio: "25/03/2025",
        fechaFin: "16/06/2025",
        intermediario: "Incoga",
        cadena: "Oysho",
        tipoCentro: "Obra nueva",
        estado: "EN PROCESO",
        codigoEspacio: "#10246",
        codigoObra: "-",
        badgeIcon: <MdWarning />,
        cumplimiento: "En proceso",
        cantidadGenerada: "1800 kg",
        coste: "950 €",
        valorizacion: 72,
    },
    {
        id: 4,
        nombre: "Oysho San Sebastián",
        direccion: "Loyola 1, San Sebastián, España",
        lat: 43.318,
        lng: -1.9812,
        fechaInicio: "18/03/2025",
        fechaFin: "22/05/2025",
        intermediario: "Liñagar",
        cadena: "Oysho",
        tipoCentro: "Obra reforma",
        estado: "VALIDADO",
        codigoEspacio: "#10314",
        codigoObra: "R12",
        badgeIcon: <BiCheck />,
        cumplimiento: "Validado",
        cantidadGenerada: "2500 kg",
        coste: "1300 €",
        valorizacion: 89,
    },
    {
        id: 5,
        nombre: "Stradivarius Belfast",
        direccion: "28 Donegall Place, Belfast, Reino Unido",
        lat: 54.5973,
        lng: -5.9301,
        fechaInicio: "23/06/2025",
        fechaFin: "04/09/2025",
        intermediario: "Spacebuild",
        cadena: "Stradivarius",
        tipoCentro: "Obra nueva",
        estado: "SIN DATOS",
        codigoEspacio: "#10840",
        codigoObra: "R1",
        badgeIcon: <MdInfo />,
        cumplimiento: "Sin datos",
        cantidadGenerada: "1600 kg",
        coste: "850 €",
        valorizacion: 45,
    },
    {
        id: 6,
        nombre: "Zara Home Roncadelle",
        direccion: "Elnos Shopping, Roncadelle, Italia",
        lat: 45.5358,
        lng: 10.1347,
        fechaInicio: "03/02/2025",
        fechaFin: "03/04/2025",
        intermediario: "Kotablue",
        cadena: "Zara Home",
        tipoCentro: "Obra reforma",
        estado: "VALIDADO",
        codigoEspacio: "#11025",
        codigoObra: "R2",
        badgeIcon: <BiCheck />,
        cumplimiento: "Validado",
        cantidadGenerada: "2800 kg",
        coste: "1450 €",
        valorizacion: 92,
    },
    {
        id: 7,
        nombre: "Zara Home Knokke",
        direccion: "Van Bunnenplein, Knokke, Bélgica",
        lat: 51.3506,
        lng: 3.2787,
        fechaInicio: "08/01/2025",
        fechaFin: "12/06/2025",
        intermediario: "Liñagar",
        cadena: "Zara Home",
        tipoCentro: "Obra nueva",
        estado: "VALIDADO",
        codigoEspacio: "#1118",
        codigoObra: "-",
        badgeIcon: <BiCheck />,
        cumplimiento: "Validado",
        cantidadGenerada: "2100 kg",
        coste: "1200 €",
        valorizacion: 86,
    },
    {
        id: 8,
        nombre: "Stradivarius Lieusaint",
        direccion: "Westfield Carré Senart, Lieusaint, Francia",
        lat: 48.6341,
        lng: 2.5519,
        fechaInicio: "29/04/2025",
        fechaFin: "01/08/2025",
        intermediario: "Incoga",
        cadena: "Stradivarius",
        tipoCentro: "Obra nueva",
        estado: "SIN DATOS",
        codigoEspacio: "#11562",
        codigoObra: "--",
        badgeIcon: <MdInfo />,
        cumplimiento: "Sin datos",
        cantidadGenerada: "1400 kg",
        coste: "750 €",
        valorizacion: 38,
    },
    {
        id: 9,
        nombre: "Stradivarius Maastricht",
        direccion: "Kleine Staat, Maastricht, Holanda",
        lat: 50.8514,
        lng: 5.6913,
        fechaInicio: "10/02/2025",
        fechaFin: "07/03/2025",
        intermediario: "Incoga",
        cadena: "Stradivarius",
        tipoCentro: "Obra menor",
        estado: "VALIDADO",
        codigoEspacio: "#11563",
        codigoObra: "OM9",
        badgeIcon: <BiCheck />,
        cumplimiento: "Validado",
        cantidadGenerada: "1900 kg",
        coste: "1000 €",
        valorizacion: 83,
    },
    {
        id: 10,
        nombre: "Pull&Bear Savignano",
        direccion: "CC Romagna, Savignano sul Rubicone, Italia",
        lat: 44.0995,
        lng: 12.4014,
        fechaInicio: "07/01/2025",
        fechaFin: "31/01/2025",
        intermediario: "Kotablue",
        cadena: "Pull&Bear",
        tipoCentro: "Obra reforma",
        estado: "VALIDADO",
        codigoEspacio: "#11694",
        codigoObra: "",
        badgeIcon: <BiCheck />,
        cumplimiento: "Validado",
        cantidadGenerada: "2300 kg",
        coste: "1250 €",
        valorizacion: 88,
    },
];

const MapaTab = ({ centrosProductoresData: externalData, filters }) => {
    const [centrosProductores, setCentrosProductores] = useState(
        centrosProductoresMapData
    );
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (externalData && externalData.length > 0) {
            const mapFormattedData = externalData.map((centro) => ({
                ...centro,
                lat: centro.lat || 40.4168,
                lng: centro.lng || -3.7038,
                nombre: centro.cadena + " " + centro.codigoEspacio,
                direccion: centro.direccion || "Ubicación no especificada",
                cumplimiento: centro.estado,
                badgeIcon:
                    centro.estado === "VALIDADO" ? (
                        <BiCheck />
                    ) : centro.estado === "EN PROCESO" ? (
                        <MdWarning />
                    ) : (
                        <MdInfo />
                    ),
                cantidadGenerada: centro.cantidadGenerada || "0 kg",
                coste: centro.coste || "0 €",
                valorizacion: centro.valorizacion || 0,
            }));
            setCentrosProductores(mapFormattedData);
        }
    }, [externalData]);

    const fetchCentrosProductoresMap = async () => {
        setLoading(true);
        try {
            setCentrosProductores(centrosProductoresMapData);
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar los centros productores en el mapa. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCentrosProductoresMap();
    }, []);

    if (loading) {
        return (
            <div className="mapa-tab__loading">
                Cargando mapa de centros productores...
            </div>
        );
    }

    if (error) {
        return <div className="mapa-tab__error">Error: {error}</div>;
    }

    return (
        <div className="mapa-tab">
            <div className="mapa-tab__content">
                <MapComponent
                    data={centrosProductores}
                    center={[50.0, 10.0]}
                    zoom={4}
                    height="600px"
                    width="100%"
                />
            </div>
        </div>
    );
};

export default MapaTab;
